import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createPlanAndRateOverrideRule } from '../../../api/plan-and-rate-override-rules-api'
import type {
  CreatePlanAndRateOverrideRuleRequestDto,
  PlanAndRateOverrideRuleResponseDto,
} from '../../../api/dto/plan-and-rate-override-rules.dto'
import { PLAN_AND_RATE_OVERRIDE_RULES_QUERY_KEY } from '../pages/ListPlanAndRateOverride/hooks/useGetPlanAndRateOverrideRules'

export function useCreatePlanAndRateOverrideRule() {
  const queryClient = useQueryClient()

  return useMutation<
    PlanAndRateOverrideRuleResponseDto,
    unknown,
    CreatePlanAndRateOverrideRuleRequestDto
  >({
    mutationFn: (body) => createPlanAndRateOverrideRule(body),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [PLAN_AND_RATE_OVERRIDE_RULES_QUERY_KEY],
      })
    },
  })
}
